<app-header>
    <div class="filters">
        <mat-form-field appearance="outline" [ngClass]="{'resize-form-field': selectedDomainId,'force-focus': domainControl.value}">
            <mat-label>Select Domain</mat-label>

            <input type="text" matInput [matAutocomplete]="domainOptions" [formControl]="domainControl" (input)="onDomainInput($event)"/>
            <mat-autocomplete #domainOptions="matAutocomplete" [displayWith]="displayDomainNameFn" (optionSelected)="onDomainSelect()">
                <mat-option *ngFor="let domain of filteredDomains | async" [value]="domain">{{domain.domainName}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" [ngClass]="{'resize-form-field': selectedDomainId,'force-focus': domainControl.value}">
            <mat-label>Select Subdomain</mat-label>

            <input type="text" matInput [matAutocomplete]="subdomainOptions" [formControl]="subdomainControl" (input)="onSubDomainInput($event)"/>
            <mat-autocomplete #subdomainOptions="matAutocomplete" [displayWith]="displaySubdomainNameFn" (optionSelected)="onSubdomainSelect()">
                <mat-option *ngFor="let subdomain of filteredSubdomains | async" [value]="subdomain">{{subdomain.subdomainName}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field appearance="outline" [ngClass]="{'resize-form-field': selectedDomainId,'force-focus': domainControl.value}">
            <mat-label>Select Site</mat-label>

            <input type="text" matInput  [matAutocomplete]="siteOptions" [formControl]="siteControl" (input)="onSiteInput($event)"/>
            <mat-autocomplete #siteOptions="matAutocomplete" [displayWith]="displaySiteNameFn" (optionSelected)="onSiteSelect()">
                <mat-option *ngFor="let site of filteredSites | async" [value]="site">{{site.name}}</mat-option>
            </mat-autocomplete>
        </mat-form-field>

         <div class="date-picker-button-wrapper content-wrapper" *ngIf="selectedDomainId">
            <div class="label-wrapper date-range">
                    <label>Date Range:</label>
                </div>
            <input matInput [matDatepicker]="startPicker" class="hidden-date-picker"
                (dateChange)="onDateChange($event, 'startDate')" #dummyInput>
            <mat-datepicker #startPicker></mat-datepicker>
            <button class="date-select-btn" (click)="startPicker.open()">
                {{ selectedStartDate ? (selectedStartDate | date: 'dd-MM-yyyy') : 'Start Date' }}
                <mat-icon>expand_more</mat-icon>
                <mat-icon *ngIf="selectedStartDate" class="clear-icon" (click)="clearDate('startDate', $event)">close</mat-icon>
            </button>

            <input matInput [matDatepicker]="endPicker" class="hidden-date-picker"
                (dateChange)="onDateChange($event, 'endDate')">
            <mat-datepicker #endPicker></mat-datepicker>
            <button class="date-select-btn" [disabled]="!selectedStartDate" (click)="endPicker.open()">
                {{ selectedEndDate ? (selectedEndDate | date: 'dd-MM-yyyy') : 'End Date' }}
                <mat-icon>expand_more</mat-icon>
                <mat-icon *ngIf="selectedEndDate" class="clear-icon" (click)="clearDate('endDate', $event)">close</mat-icon>
            </button>
        </div>

        <div class="timeline-container content-wrapper" *ngIf="selectedDomainId">
            <div class="label-wrapper">
                <label>Timeline:</label>
            </div>
            <mat-button-toggle-group class="circle-group">
                <mat-button-toggle *ngFor="let option of options" [value]="option" class="circle-toggle"
                                    [ngClass]="{'selected': selectedTimeline === option}"
                                    (click)="toggleSelection(option)">
                    <span>{{ option }}</span>
                </mat-button-toggle>
                </mat-button-toggle-group>
        </div>
    </div>

</app-header>

<mat-drawer-container class="parent-container">
    <mat-drawer #drawer mode="side" class="sidenav-container" opened="true">
        <div class="logo-container">
            <a mat-icon-button (click)="navigateToDomain()" class="logo">
				<app-logo></app-logo>
			</a>
        </div>
        <mat-button-toggle-group class="sidenav-items" [(ngModel)]="selectedItem"
            (ngModelChange)="updateSideNav($event)" vertical="true">
            <mat-button-toggle value="executive" [ngClass]="{'matlist-active': selectedItem === 'executive', 'hover-active': selectedItem === 'executive'}" matTooltip="Executive">
                <mat-icon svgIcon="overview" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="drillAndBlast" [ngClass]="{'matlist-active': selectedItem === 'drillAndBlast', 'hover-active': selectedItem === 'drillAndBlast'}" (click)="selectedItem = 'drillAndBlast'" matTooltip="Blast Design">
                <mat-icon svgIcon="blastDesign" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="fragmentation" [ngClass]="{'matlist-active': selectedItem === 'fragmentation', 'hover-active': selectedItem === 'fragmentation'}" (click)="selectedItem = 'fragmentation'" matTooltip="Blast Performance">
                <mat-icon svgIcon="blastPerformance" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="fielder" [ngClass]="{'matlist-active': selectedItem === 'fielder', 'hover-active': selectedItem === 'fielder'}" matTooltip="Drilling KPI">
                <mat-icon svgIcon="drillKPI" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="inventory" [ngClass]="{'matlist-active': selectedItem === 'inventory', 'hover-active': selectedItem === 'inventory'}" matTooltip="Inventory">
                <mat-icon svgIcon="inventoryDashboard" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="dataCollection" [ngClass]="{'matlist-active': selectedItem === 'dataCollection', 'hover-active': selectedItem === 'dataCollection'}" (click)="selectedItem = 'dataCollection'" matTooltip="Database">
                <mat-icon svgIcon="database" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="drillAndBlastCosts" [ngClass]="{'matlist-active': selectedItem === 'drillAndBlastCosts', 'hover-active': selectedItem === 'drillAndBlastCosts'}" (click)="selectedItem = 'drillAndBlastCosts'" matTooltip="Drill And Blast Costs">
                <mat-icon svgIcon="cost" class="maticon"></mat-icon>
            </mat-button-toggle>

            <mat-button-toggle value="operationalDataCollection" [ngClass]="{'matlist-active': selectedItem === 'operationalDataCollection', 'hover-active': selectedItem === 'operationalDataCollection'}" (click)="selectedItem = 'operationalDataCollection'" matTooltip="Operational Data Collection">
                <mat-icon svgIcon="operationaldata" class="maticon"></mat-icon>
            </mat-button-toggle>

        </mat-button-toggle-group>
    </mat-drawer>

    <div class="content-container" [class.sidenav-closed]="!drawer.opened">
        <div class="main-content">
            <div class="domain-loading-container" *ngIf="!domains">
                <mat-spinner></mat-spinner>
                <span>Loading your data. Please wait...</span>

                <div class="loading-logo-overlay">
                    <app-logo></app-logo>

                    <div class="animate"></div>
                </div>
            </div>

            <app-executive-overview-dashboard *ngIf="selectedItem === 'executive' && selectedDomainId" ></app-executive-overview-dashboard>

            <app-drill-and-blast-dashboard *ngIf="selectedItem === 'drillAndBlast' && selectedDomainId"></app-drill-and-blast-dashboard>

            <app-fragmentation-dashboard *ngIf="selectedItem === 'fragmentation' && selectedDomainId"></app-fragmentation-dashboard>

            <app-fielder-dashboard *ngIf="selectedItem === 'fielder' && selectedDomainId"></app-fielder-dashboard>

            <app-inventory-dashboard *ngIf="selectedItem === 'inventory' && selectedDomainId"></app-inventory-dashboard>

            <app-data-collection-view *ngIf="selectedItem === 'dataCollection' && selectedDomainId"></app-data-collection-view>

            <app-drill-and-blast-costs *ngIf="selectedItem === 'drillAndBlastCosts' && selectedDomainId"></app-drill-and-blast-costs>

            <app-operational-data-collection *ngIf="selectedItem === 'operationalDataCollection' && selectedDomainId"></app-operational-data-collection>
        </div>
    </div>
</mat-drawer-container>

